module.exports = __webpack_public_path__ + "static/img/kyc-drawback.9d4b5334.svg";